<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <!-- Header -->
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{ $t('People') }}</h6>
                                <h1 class="header-title">{{ $t('Dispatch') }}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-9">
                        <div class="card">
                            <div class="card-header">
                                <div class="row align-items-center">
                                    <!-- search -->
                                    <div class="col order-lg-0">
                                    </div>
                                    <div :class="isMobileFilter ? '' : 'd-none d-sm-block'" class="col-lg-auto col order-3">
                                        <tags v-model="tags" :label="$t('Tags')"></tags>
                                    </div>

                                    <!-- team filter -->
                                    <div :class="isMobileFilter ? '' : 'd-none d-sm-block'" class="col-lg-auto col order-3">
                                        <permission-check resource="customers" see-all>
                                            <team-filter v-model="user"></team-filter>
                                        </permission-check>
                                    </div>
                                    <!-- date filter -->
                                    <div :class="isMobileFilter ? '' : 'd-none d-sm-block'" class="col-lg-auto col order-4">
                                        <date-filter v-model="dates"></date-filter>
                                    </div>
                                    <!-- gender filter -->
                                    <div :class="isMobileFilter ? '' : 'd-none d-sm-block'" class="col-lg-auto col order-5">
                                        <div class="dropdown">
                                            <b-dropdown variant="white" right :text="$t('Gender')">
                                                <div class="p-2">
                                                    <b-form-checkbox
                                                        v-model="gender"
                                                        value="female"
                                                        class="mb-3"
                                                    >{{$t('Female')}}
                                                    </b-form-checkbox>
                                                    <b-form-checkbox v-model="gender" value="male" class="mb-3">{{$t('Male')}}</b-form-checkbox>
                                                </div>
                                            </b-dropdown>
                                        </div>
                                    </div>

                                    <!-- dividers -->
                                    <div
                                        :class="isMobileFilter ? 'd-block d-sm-none' : 'd-none'"
                                        class="dropdown-divider col-12 order-2"
                                    ></div>

                                    <!-- filter button -->
                                    <div class="col-auto d-block d-sm-none order-1 mt-3 mb-3 ml-1">
                                        <b-button @click="isMobileFilter = !isMobileFilter" variant="white" size="lg">
                                            <i class="fe fe-filter"></i>
                                        </b-button>
                                    </div>
                                </div>
                                <!-- / .row -->
                            </div>

                            <simple-table
                                :data="customers"
                                :onSort="setSort"
                                :loading="areCustomersLoading"
                                :edit="false"
                                :deleteItem="deleteItem"
                                :columns="columns"
                                :sort="sort"
                                :actions="false"
                            ></simple-table>
                        </div>
                        <button class="btn btn-outline-secondary ml-2">{{$t("Dispatch")}}</button>
                    </div>
                    <div class="col-3">
                        <div class="card">
                            <div class="card-body">
                                {{templates}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-3 text-center" v-if="totalRows > perPage">
                    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage"/>
                </div>
            </div>
        </div>
        <dispatch-modal id="DispatchModal"></dispatch-modal>
    </div>
</template>

<script>

    import Tags from "@/components/Tags.vue";
    import SimpleTable from '@/components/SimpleTable.vue'
    import Doughnut from '@/components/Charts/Doughnut.vue'
    import {modalMixins} from '@/mixins/modal.js'
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import debounce from 'lodash/debounce';
    import DateFilter from '@/components/DateFilter.vue';
    import TeamFilter from '@/components/TeamFilter.vue';
    import Money from '@/components/Money.vue';
    import DispatchModal from "./DispatchModal";


    export default {
        mixins: [modalMixins],
        components: {
            DispatchModal,
            Doughnut,
            DateFilter,
            TeamFilter,
            SimpleTable,
            Money,
            Tags,
        },
        data() {
            return {
                isMobileFilter: false,
                debtors: 0,
                prepaid: 0,
                totalCustomers: 0,
                totalRows: 0,
                filter: 'debtors',
                genderChart: [],
                archived: 0,
                tags: [],

                customerDefaults: {
                    avatar_id: null,
                    avatar: {},
                    gender: 'female',
                    allow_general_sms: true,
                    allow_promo_sms: true
                },

                modalName: 'customerFormModal',
                query: null,
                user: [],
                params: {},
                currentPage: 1,
                perPage: 10,
                sort: 'createdAt',
                order: -1,
                gender: [],
                labels: {
                    'today': 'Today',
                    'yesterday': 'Yesterday',
                    'this_week': 'This week',
                    'previous_week': 'Previous week',
                    'this_month': 'This month',
                    'previous_month': 'Previous month',
                },
                date: null,
                dates: {},
                date_range: null,
                calendarOptions: {
                    wrap: true,
                    mode: "range",
                    positionElement: this.appendHere,
                    altFormat: 'F j, Y',
                    dateFormat: "F j, Y",
                    ariaDateFormat: 'd.m.Y',
                    maxDate: new Date(),
                },
                model: {},
                errors: {},
                columns: [
                    {
                        label: '',
                        name: 'status',
                        width: 1,
                        field: (item) => {
                            if (item.blacklisted)
                                return `<span v-b-tooltip title="Blacklisted"  class="fe fe-alert-triangle text-warning" ></span>`;

                            let a = [];
                            if (item.tags && item.tags.length > 0) {

                                let tags = item.tags.map(tag => {
                                    let tagItem = this.getTag(tag);
                                    if (!tagItem) return;
                                    return '<span class="mr-2  m-0 p-0  h1  text-' + tagItem.color + '">•</span>';

                                });

                                a.push(tags.join(''));
                            }

                            return a.join('<br >');
                        }
                    },
                    {
                        label: 'Image',
                        name: 'preview',
                        image: true,
                        width: 50,
                        link: (item) => {
                            return {
                                name: 'people.customer',
                                params: {id: item._id}
                            }
                        },
                        field: (item) => {
                            if (item.avatar) {
                                return item.avatar.preview;
                            }
                        }
                    },
                    {
                        label: 'Name',
                        name: 'first_name',
                        sortable: true,
                        link: (item) => {
                            return {
                                name: 'people.customer',
                                params: {id: item._id}
                            }
                        },
                        subtitle: (item) => {
                            let a = [item.phone, item.email];
                            return a.join('<br >');
                        },
                        field: (item) => {
                            let field = [item.first_name, item.last_name];
                            return field.join(' ');
                        }
                    },
                    {
                        label: 'Discount',
                        name: 'discountPercent',
                        sortable: true,
                        field(item) {

                            return ((item.discountPercent) ? item.discountPercent : 0) + ' <span class="small text-muted">%</span>';
                        }

                    },
                    {
                        label: 'Balance',
                        name: 'balance',
                        sortable: true,
                        money: (item) => {
                            return item.balance;
                        },
                        subtitle: (item) => {
                            if (item.debtReturn && item.debtReturn.date) {
                                let message = ` <div>  ${this.$moment(item.debtReturn.date).format('DD MMM dddd, YYYY')} </div>`
                                if (item.debtReturn.text) message += `<i class="fe fe-message-square"></i> ${item.debtReturn.text}`;
                                return message
                            }
                        },
                    },
                    {
                        label: 'Gender',
                        name: 'gender',
                        sortable: true,
                        field: (item) => {
                            return ` ${this.$t(item.gender)}`;
                        }
                    },
                    {
                        label: 'Age',
                        name: 'birth_date',
                        sortable: true,
                        field: (item) => {
                            if (item.birth_date) {
                                let age = this.$moment().diff(item.birth_date, 'years');
                                return age || 0;
                            } else
                                return '-';
                        }
                    },
                    {
                        label: 'Date',
                        name: 'createdAt',
                        sortable: true,
                        duration: true,
                    }
                ],
                // customers: [],
            };
        },
        computed: {
            ...mapState('dispatcher', {areCustomersLoading: 'isFindPending'}),
            ...mapGetters('dispatcher', {findCustomersInStore: 'find'}),
            ...mapGetters('dispatch', {findTemplatesInStore: 'find'}),
            ...mapGetters('tags', {
                getTag: 'get'
            }),

            byDateLabel() {
                if (this.date_range == 'custom') {
                    return this.date;
                } else
                    return this.labels[this.date_range];
            },

            customers() {
                let localParams = Object.assign(this.params.query);
                return this.findCustomersInStore(localParams).data;
            },

            templates() {
                return this.findTemplatesInStore({}).data
            }

        },
        watch: {
            filter: function (newVal) {
                this.findCustomers();
            },
            tags: debounce(function (newVal) {
                this.findCustomers();
            }, 400),
            query: debounce(function (newVal) {

                this.findCustomers();
            }, 400),
            gender: debounce(function (newVal) {
                this.findCustomers();
            }, 400),
            currentPage: debounce(function (newVal) {

                this.findCustomers();
            }, 400),
            dates: debounce(function (newVal) {
                this.findCustomers();
            }, 400),
            user(newVal) {
                this.findCustomers();
            }
        },
        created() {
            this.filter = this.$route.params.filter;
            this.findCustomers();
            this.fetchTemplates()
        },
        methods: {
            ...mapActions('dispatcher', ['find', 'remove', 'create', 'patch']),
            ...mapActions('dispatch', {findTemplates: 'find'}),
            ...mapMutations('dispatcher', {
                clearCustomers: 'clearAll' // lets you do `this.clearTodos()` inside the component
            }),

            setSort(field, order) {
                this.sort = field;
                this.order = order;
                this.findCustomers();
            },

            clearDateRange() {
                this.date_range = null;
                this.date = null;
                this.dates = {};
                this.findCustomers();
            },

            created() {
                this.filter = this.$route.params.filter;
                this.findCustomers();
            },

            openDatePicker() {
                const flatPickrInstance = this.$refs.datePickerWrap.fp;
                flatPickrInstance._positionElement = window.document.getElementById('appendHere'); // eslint-disable-line
                flatPickrInstance.open();
            },

            fetchTemplates() {
                let query = {};
                this.findTemplates({query})
            },

            findCustomers() {
                this.clearCustomers();
                let params = {
                    query: {
                        $limit: this.perPage,
                        $skip: (this.currentPage - 1) * this.perPage,
                        $sort: {
                            [this.sort]: this.order
                        }
                    }
                };


                if (this.tags.length > 0) {
                    params.query.tags = {$in: this.tags};
                } else {
                    delete params.query.tags;
                }

                if (this.query) {
                    // params.query.$search = this.query;
                    params.query.$skip = 0;
                    params.query.$or = [
                        {first_name: {$regex: this.query, $options: "i"}},
                        {last_name: {$regex: this.query, $options: "i"}},
                        {phone: {$regex: this.query, $options: "i"}},
                    ];
                }

                if (this.user.length > 0) {
                    params.query.userId = {$in: this.user};
                } else {
                    delete params.query.userId;
                }

                if (this.gender.length > 0) {
                    params.query.gender = {$in: this.gender};
                }

                if (this.dates.start && this.dates.end) {
                    params.query.createdAt = {
                        $gte: this.dates.start,
                        $lte: this.dates.end
                    }
                }

                if (this.filter) {
                    if (this.filter === 'debtors')
                        params.query.balance = {$lt: 0};
                    if (this.filter === 'prepaid')
                        params.query.balance = {$gt: 0};
                    if (this.filter === 'archived') {
                        params.query.deleted = true;
                    }

                    if (this.filter === 'upcoming')
                        params.query.debtReturn = {
                            date: {
                                $gte: this.$moment(),
                                $lte: this.$moment().endOf('month'),
                            }
                        };
                    if (this.filter === 'outdated')
                        params.query.debtReturn = {
                            date: {
                                $lte: this.$moment(),
                            }
                        };
                }

                this.params = params;


                this.find(params).then(data => {

                    this.genderChart = data.meta;
                    this.archived = data.archived;
                    this.totalCustomers = data.totalCustomers;
                    this.totalRows = data.total;
                    this.debtors = data.debtors;
                    this.prepaid = data.prepaid;


                });
            },

            edit(item) {
                this.openModal({
                    id: 'customerFormModal',
                    model: item
                })
            },

            deleteItem(item) {
                this.remove(item._id).then(data => {
                    this.$toasted.global.success({
                        message: 'Customer deleted'
                    });
                })
            }
        }
    }
</script>
